export default "__VITE_ASSET__8f4d9073__"